/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import { PATHS } from '../../../global/constants'

export const collectOption =[
    {
        title:"Writing",
        path: PATHS.admin.name+PATHS.myCollections.writeCollect.name
    }, 
    { 
        title:"Listening",
        path: PATHS.admin.name+PATHS.myCollections.listenCollect.name
    }, 
    {   
        title:"Speaking",
        path: PATHS.admin.name+PATHS.myCollections.speakCollect.name
    }, 
    {   
        title:"Reading",
        path: PATHS.admin.name+PATHS.myCollections.readCollect.name
    }
]

export const speakingData=[
    {
        id:"RA-1",
        type:"RA",
        number: "0",
        content:""
    },
    {
        id:"RL-1",
        type:"RL",
        number: "0",
        content:""
    },
    {
        id:"RS-1",
        type:"RS",
        number: "0",
        content:""
    },
    {
        id:"DI-1",
        type:"DI",
        number: "0",
        content:""
    },
    {
        id:"ASQ-1",
        type:"ASQ",
        number: "0",
        content:""
    }

]

export const readingData=[
    {
        id:"RFIB-1",
        type:"RFIB",
        number: "0",
        content:""
    },
    {
        id:"RMCM-1",
        type:"RMCM",
        number: "0",
        content:""
    },
    {
        id:"RMCS-1",
        type:"RMCS",
        number: "0",
        content:""
    },
    {
        id:"RO-1",
        type:"RO",
        number: "0",
        content:""
    },
    {
        id:"RWFIB-1",
        type:"RWFIB",
        number: "0",
        content:""
    }
]

export const listeningData=[
    {
        id:"SST-1",
        type:"SST",
        number: "0",
        content:""
    },
    {
        id:"MCM-1",
        type:"MCM",
        number: "0",
        content:""
    },
    {
        id:"MCS-1",
        type:"MCS",
        number: "0",
        content:""
    },
    {
        id:"FIB-1",
        type:"FIB",
        number: "0",
        content:""
    },
    {
        id:"HIW-1",
        type:"HIW",
        number: "0",
        content:""
    },
    {
        id:"HCS-1",
        type:"HCS",
        number: "0",
        content:""
    },
    {
        id:"SMW-1",
        type:"SMW",
        number: "0",
        content:""
    },
    {
        id:"WFD-1",
        type:"WFD",
        number: "0",
        content:""
    }
]

export const writingData=[
    {
        id:"WE-1",
        type:"WE",
        number: "0",
        content:""
    },
    {
        id:"SMW-1",
        type:"SMW",
        number: "0",
        content:""
    }
]